export default __webpack_public_path__ + "static/media/klient-img.8159b839.jpg";